import * as React from 'react';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';

import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { TimelineDot } from '@mui/lab';
import LocationOnIcon from '@mui/icons-material/LocationOn';


export default function TimeLineComp({title,orgName,loc,year,Icon,connector}) {
    const [isHovered, setIsHovered] = React.useState(false);
  return (
      <TimelineItem 
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        data-aos="fade-up" data-aos-duration="2000"
      >
        <TimelineSeparator>
          
          <TimelineDot sx={{
            backgroundColor:'primary.main',
            transition:"all 0.1s linear 0s",
            transform:isHovered?"scale(1.2)":"scale(1)",
            

          }}>
            <Icon />
          </TimelineDot>
          {connector?<TimelineConnector />:""}
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
            <Box sx={{display:"flex", justifyContent:"space-between"}}>
                <Typography variant="h6" component="div" sx={{color:"text.primary"}}>
                    {title}
                </Typography>
                <Typography variant="h7" component="div" sx={{color:"text.primary"}}>
                    {year}
                </Typography>
            </Box>
            <Box sx={{display:"flex", justifyContent:"space-between"}}>
                <Typography variant="h7" component="div" sx={{color:"text.primary"}}>
                    {orgName}
                </Typography>
                <Typography variant="h7" component="div" sx={{color:"text.primary",display:"flex"}}>
                    <LocationOnIcon sx={{fontSize:"20px"}}/>
                    <Typography>
                        {loc}
                    </Typography>
                </Typography>
            </Box>
        </TimelineContent>
      </TimelineItem>
  );
}